import React from 'react';
import { Segment, Header, Grid } from 'semantic-ui-react';
import TestChart from './TestChart';

export default function SubcategoryPanel({ category, subcategory, results }) {
  const testNames = Object.keys(results);

  if (testNames.length === 0) {
    return null; // Don't show empty subcategories
  }

  return (
    <Segment>
      <Header as="h3">{subcategory}</Header>
      <Grid columns={4} stackable>
        {testNames.map(testName => (
          <Grid.Column key={testName}>
            <TestChart testName={testName} />
          </Grid.Column>
        ))}
      </Grid>
    </Segment>
  );
}
